
const statusHandler = {
    methods: {
        getStatus ( content_type, results ) {
            const result = {
                1: content_type  == 'news' ? 'active_f' : content_type  == 'library_file' ? 'active': content_type  == 'presential_event_catalog' ? 'pre_scheduled' : 'published',
                2: content_type  == 'news' ? 'inactive_f' : content_type  == 'library_file' ? 'inactive' : content_type  == 'presential_event_catalog' ? 'scheduled' : 'unpublished',
                3: content_type  == 'news' ? 'deleted_f' : content_type  == 'presential_event_catalog' ? 'in_progress' : 'deleted',
                4: content_type  == 'presential_event_catalog' ? 'intermission' :'finished',
                5: content_type == 'webcast' ? 'in_conversion' : content_type == 'presential_event_catalog' ? 'awaiting_result_plural' : 'presencial_published',
                6: content_type == 'webcast' ? 'presential_published' ? content_type == 'presential_event_catalog': 'reproved' : 'presential_unpublished',
                7: content_type == 'webcast' ? 'presential_unpublished' ? content_type == 'presential_event_catalog' : 'canceled' : 'presential_finished',
                8: content_type == 'webcast' ? 'presential_finished'  : 'finished',
                9: 'model',
                10: 'deleted'
            }
            return result[results]
        },

        getColorStatus(content_type, results) {
            const colors = {
                info: 'info',
                warning: 'warning',
                negative: 'negative',
                positive: 'positive'
            }
            const result = {
                1: colors.info,
                2: content_type == 'presential_event_catalog' ? colors.info : colors.warning,
                3: content_type == 'presential_event_catalog' ? colors.info : colors.negative,
                4: content_type == 'presential_event_catalog' ? colors.info : colors.positive,
                5: colors.info,
                6: content_type == 'presential_event_catalog' ? colors.negative : colors.info,
                7: content_type == 'webcast' ? colors.info : content_type == 'presential_event_catalog' ? colors.negative : colors.info,
                8: colors.positive,
                9:  colors.info,
                10: colors.warning,
            }

            return result[results]
        }
    }
}

export default statusHandler